import { REGULATOR } from 'constants/regulators';

export const PERSONAL_DETAILS_FORM = 'PERSONAL_DETAILS_FORM';
export const CYSEC_PERSONAL_DETAILS_FORM = 'CYSEC_PERSONAL_DETAILS_FORM';
export const PRIMARY_PERSONAL_DETAILS_SECTION = 'primary';
export const ADDRESS_DETAILS_SECTION = 'address';
export const JURISDICTION_DETAILS_SECTION = 'jurisdiction';
export const CITY_RESTRICTOR_MODAL = 'CITY_RESTRICTOR_MODAL';
export const COUNTRY_RESTRICTOR_MODAL = 'COUNTRY_RESTRICTOR_MODAL';
export const BANNED_COUNTRIES_MODAL = 'BANNED_COUNTRIES_MODAL';
export const BANNED_PERSON_MODAL = 'BANNED_PERSON_MODAL';

export const COUNTRY_RESTRICTOR_MESSAGE_KEY = {
  [REGULATOR.ASIC]: 'countryRestrictor:text.ASIC',
  [REGULATOR.VFSC]: 'countryRestrictor:text.default',
  [REGULATOR.SEY]: 'countryRestrictor:text.default',
  [REGULATOR.CYSEC]: 'countryRestrictor:text.default',
};

export const MAP_PERSONAL_DETAILS = {
  [PRIMARY_PERSONAL_DETAILS_SECTION]: [
    'firstName',
    'lastName',
    'dateOfBirth',
    'phoneInfo',
    'countryOfBirth',
    'nationality',
  ],
  [ADDRESS_DETAILS_SECTION]: ['addressLine1', 'city', 'zipCode', 'state', 'country'],
  [JURISDICTION_DETAILS_SECTION]: [
    'jurisdictionCountry',
    'jurisdiction',
    'tin',
    'tinOption',
    'tinOptionComment',
  ],
};

export const JURISDICTION_VALUES = {
  YES: 'yes',
  NO: 'no',
};

export const JURISDICTION_OPTIONS = [
  { value: JURISDICTION_VALUES.YES, label: 'Yes' },
  { value: JURISDICTION_VALUES.NO, label: 'No' },
];

export const TIN_VALUE_OPTIONS = {
  NOT_REQUIRED: 'notRequired',
  NOT_COUNTRY_TIN: 'notCountryTin',
  UNABLE_TIN: 'unableTin',
};

export const TIN_OPTIONS = [
  {
    value: TIN_VALUE_OPTIONS.NOT_REQUIRED,
    label: 'profile:cySecVerification.personalDetails.tinOptions.notRequired',
  },
  {
    value: TIN_VALUE_OPTIONS.NOT_COUNTRY_TIN,
    label: 'profile:cySecVerification.personalDetails.tinOptions.notCountryTin',
  },
  {
    value: TIN_VALUE_OPTIONS.UNABLE_TIN,
    label: 'profile:cySecVerification.personalDetails.tinOptions.unableTin',
  },
];
